import React from 'react';
import { sanitizeAmountInput, formatAmountInputDisplay } from '../../utils/amount';

/**
 * Saisie montant sans type="number" (évite 100 → 99,99 et la molette).
 */
const AmountInput = ({
    value,
    onChange,
    currency = 'CDF',
    className = '',
    placeholder,
    disabled = false,
    id,
    name,
    'aria-label': ariaLabel,
}) => {
    const isCdf = (currency || 'CDF').toUpperCase() === 'CDF';

    const handleChange = (e) => {
        onChange(sanitizeAmountInput(e.target.value, currency));
    };

    const handleBlur = () => {
        if (value === '' || value == null) return;
        onChange(formatAmountInputDisplay(value, currency));
    };

    return (
        <input
            type="text"
            inputMode={isCdf ? 'numeric' : 'decimal'}
            autoComplete="off"
            id={id}
            name={name}
            aria-label={ariaLabel}
            value={value ?? ''}
            onChange={handleChange}
            onBlur={handleBlur}
            onWheel={(e) => e.currentTarget.blur()}
            disabled={disabled}
            placeholder={placeholder ?? (isCdf ? 'Ex: 15000' : 'Ex: 99.50')}
            className={className}
        />
    );
};

export default AmountInput;
